

































































import teipTable from '@/components/partials/teip-table.vue';
import CompleteLiquidation from './completeLiquidation.vue';

import liquidationType from '@/store/types/liquidations';
import currencyCents from '@/util/transformString/currencyCents';
import { LiquidationParams } from '@/store/interfaces/liquidations';
import { navLink } from '@/ts/navegationLinks';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import { mapGetters } from 'vuex';
import Vue from 'vue';

export default Vue.extend({
  name: 'TransactionToLiquidate',
  components: {
    teipTable,
    CompleteLiquidation,
  },
  data: () => ({
    navlink: [
      {
        name: 'Transacciones a Liquidar',
        active: false,
        to: '/liquidations',
      },
      {
        name: 'Detalle',
        active: true,
      }
    ] as navLink[],
    propsToSearch: [] as tPropsToSearch,
    viewModal: false,
    status: 'pending',
    tableColumns: [
      {
        prop: 'id',
        label: 'Numero de Referencia',
        minWidth: 280,
        sortable: false,
      },
      {
        prop: 'total_cents',
        label: 'Total',
        minWidth: 180,
        sortable: false,
        formatter: (row: LiquidationParams) => {
          return `${currencyCents(row.total_cents)}`;
        },
      },
      {
        prop: 'branch_name',
        label: 'Nombre del comercio',
        minWidth: 180,
        sortable: false,
      }
    ] as tTableColumns,
    transactionsToLiquidate: [
      {
        branch_name: 'Subway Ilopango',
        completed_at: '2020-09-05',
        status: 'pending',
        total_cents: 10000,
        total_currency: 'string',
        user_id: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
      }
    ],
    rowSelected: undefined,
    showevent: false,
  }),
  computed: {
    ...mapGetters({
      getLiquidation: `liquidationModule/${liquidationType.getters.GET_SINGLE_LIQUIDATION}`,
    }),
  },
  methods: {
    completeLiquidation(): void{
      this.viewModal = true;
    },
  },
});
